// extracted by mini-css-extract-plugin
export var isPrintedCell = "_xi-1";
export var printerIcon = "_xi-0";